import { useRecoilValue } from 'recoil';

import state from 'components/state';
import {
  MYRIAD_STAFF_LABEL,
  getCreatorAvatarProps,
  getCreatorDisplayName
} from 'components/shared/ExpandableToolbar/lib/helpers';

import { HISTORY_ACTOR } from './constants';

export const useActivityCreator = (activity) => {
  const userState = useRecoilValue(state.userState);
  const permission = useRecoilValue(state.permissions);

  const { creator, created_by_type } = activity;

  const currentUserId = permission?.admin_id || userState?.id;

  const isViewerAdmin = !!permission?.admin_id;

  const isAutomation = created_by_type === HISTORY_ACTOR.AUTOMATION;

  const isCurrentUser = !isAutomation && currentUserId && creator?.id === currentUserId;
  const fullName = getCreatorDisplayName({
    creator,
    isAdminAction: created_by_type === HISTORY_ACTOR.ADMIN,
    isAutomation,
    isViewerAdmin
  });
  const displayName = isCurrentUser ? 'You' : fullName;
  const avatarProps = getCreatorAvatarProps({
    creator,
    isMasked: fullName === MYRIAD_STAFF_LABEL && !isCurrentUser,
    isAutomation
  });

  return { displayName, fullName, avatarProps };
};
